const realmadrid = [
  {
    id: 1,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 26/27 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2026",
      "2026 real",
      "2026",
      "real madrid 2026",
      "2026 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/26-27-01/uni0.jpg",
      "/images/europa/realmadrid/26-27-01/uni1.jpg",
      "/images/europa/realmadrid/26-27-01/uni2.jpg",
      "/images/europa/realmadrid/26-27-01/uni3.jpg",
      "/images/europa/realmadrid/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2025",
      "2025 real",
      "2025",
      "real madrid 2025",
      "2025 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/25-26-01/uni0.jpg",
      "/images/europa/realmadrid/25-26-01/uni1.jpg",
      "/images/europa/realmadrid/25-26-01/uni2.jpg",
      "/images/europa/realmadrid/25-26-01/uni3.jpg",
      "/images/europa/realmadrid/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2025",
      "2025 real",
      "2025",
      "real madrid 2025",
      "2025 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/25-26-02/uni0.jpg",
      "/images/europa/realmadrid/25-26-02/uni1.jpg",
      "/images/europa/realmadrid/25-26-02/uni2.jpg",
      "/images/europa/realmadrid/25-26-02/uni3.jpg",
      "/images/europa/realmadrid/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2025",
      "2025 real",
      "2025",
      "real madrid 2025",
      "2025 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/25-26-03/uni0.jpg",
      "/images/europa/realmadrid/25-26-03/uni1.jpg",
      "/images/europa/realmadrid/25-26-03/uni2.jpg",
      "/images/europa/realmadrid/25-26-03/uni3.jpg",
      "/images/europa/realmadrid/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 25/26 - Uniforme de Treino (Preta)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2025",
      "2025 real",
      "2025",
      "real madrid 2025",
      "2025 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/25-26-05-tp/uni0.jpg",
      "/images/europa/realmadrid/25-26-05-tp/uni1.jpg",
      "/images/europa/realmadrid/25-26-05-tp/uni2.jpg",
      "/images/europa/realmadrid/25-26-05-tp/uni3.jpg",
      "/images/europa/realmadrid/25-26-05-tp/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2024",
      "2024 real",
      "2024",
      "real madrid 2024",
      "2024 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/24-25-01/uni0.jpg",
      "/images/europa/realmadrid/24-25-01/uni1.jpg",
      "/images/europa/realmadrid/24-25-01/uni2.jpg",
      "/images/europa/realmadrid/24-25-01/uni3.jpg",
      "/images/europa/realmadrid/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2024",
      "2024 real",
      "2024",
      "real madrid 2024",
      "2024 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/24-25-02/uni0.jpg",
      "/images/europa/realmadrid/24-25-02/uni1.jpg",
      "/images/europa/realmadrid/24-25-02/uni2.jpg",
      "/images/europa/realmadrid/24-25-02/uni3.jpg",
      "/images/europa/realmadrid/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2024",
      "2024 real",
      "2024",
      "real madrid 2024",
      "2024 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/24-25-03/uni0.jpg",
      "/images/europa/realmadrid/24-25-03/uni1.jpg",
      "/images/europa/realmadrid/24-25-03/uni2.jpg",
      "/images/europa/realmadrid/24-25-03/uni3.jpg",
      "/images/europa/realmadrid/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 24/25 - Uniforme de Goleiro (Azul)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2024",
      "2024 real",
      "2024",
      "real madrid 2024",
      "2024 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/24-25-05-ga/uni0.jpg",
      "/images/europa/realmadrid/24-25-05-ga/uni1.jpg",
      "/images/europa/realmadrid/24-25-05-ga/uni2.jpg",
      "/images/europa/realmadrid/24-25-05-ga/uni3.jpg",
      "/images/europa/realmadrid/24-25-05-ga/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2024",
      "2024 real",
      "2024",
      "real madrid 2024",
      "2024 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/24-25-00-es/uni0.jpg",
      "/images/europa/realmadrid/24-25-00-es/uni1.jpg",
      "/images/europa/realmadrid/24-25-00-es/uni2.jpg",
      "/images/europa/realmadrid/24-25-00-es/uni3.jpg",
      "/images/europa/realmadrid/24-25-00-es/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 23/24 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2023",
      "2023 real",
      "2023",
      "real madrid 2023",
      "2023 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/23-24-01/uni0.jpg",
      "/images/europa/realmadrid/23-24-01/uni1.jpg",
      "/images/europa/realmadrid/23-24-01/uni2.jpg",
      "/images/europa/realmadrid/23-24-01/uni3.jpg",
      "/images/europa/realmadrid/23-24-01/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 23/24 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2023",
      "2023 real",
      "2023",
      "real madrid 2023",
      "2023 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/23-24-02/uni0.jpg",
      "/images/europa/realmadrid/23-24-02/uni1.jpg",
      "/images/europa/realmadrid/23-24-02/uni2.jpg",
      "/images/europa/realmadrid/23-24-02/uni3.jpg",
      "/images/europa/realmadrid/23-24-02/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 23/24 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2023",
      "2023 real",
      "2023",
      "real madrid 2023",
      "2023 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/23-24-03/uni0.jpg",
      "/images/europa/realmadrid/23-24-03/uni1.jpg",
      "/images/europa/realmadrid/23-24-03/uni2.jpg",
      "/images/europa/realmadrid/23-24-03/uni3.jpg",
      "/images/europa/realmadrid/23-24-03/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2022",
      "2022 real",
      "2022",
      "real madrid 2022",
      "2022 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/22-23-01/uni0.jpeg",
      "/images/europa/realmadrid/22-23-01/uni1.jpeg",
      "/images/europa/realmadrid/22-23-01/uni2.jpeg",
      "/images/europa/realmadrid/22-23-01/uni3.jpeg",
      "/images/europa/realmadrid/22-23-01/uni4.jpeg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 22/23 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2022",
      "2022 real",
      "2022",
      "real madrid 2022",
      "2022 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/22-23-02/uni0.jpg",
      "/images/europa/realmadrid/22-23-02/uni1.jpg",
      "/images/europa/realmadrid/22-23-02/uni2.jpg",
      "/images/europa/realmadrid/22-23-02/uni3.jpg",
      "/images/europa/realmadrid/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2021",
      "2021 real",
      "2021",
      "real madrid 2021",
      "2021 real madrid",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/21-22-02/uni0.jpg",
      "/images/europa/realmadrid/21-22-02/uni1.jpg",
      "/images/europa/realmadrid/21-22-02/uni2.jpg",
      "/images/europa/realmadrid/21-22-02/uni3.jpg",
      "/images/europa/realmadrid/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 19/20 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2019",
      "2019 real",
      "2019",
      "real madrid 2019",
      "2019 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/19-20-01-rt/uni0.png",
      "/images/europa/realmadrid/19-20-01-rt/uni1.jpg",
      "/images/europa/realmadrid/19-20-01-rt/uni2.jpg",
      "/images/europa/realmadrid/19-20-01-rt/uni3.jpg",
      "/images/europa/realmadrid/19-20-01-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 19/20 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2019",
      "2019 real",
      "2019",
      "real madrid 2019",
      "2019 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/19-20-02-rt/uni0.jpg",
      "/images/europa/realmadrid/19-20-02-rt/uni1.jpg",
      "/images/europa/realmadrid/19-20-02-rt/uni2.jpg",
      "/images/europa/realmadrid/19-20-02-rt/uni3.jpg",
      "/images/europa/realmadrid/19-20-02-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 17/18 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2017",
      "2017 real",
      "2017",
      "real madrid 2017",
      "2017 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/17-18-03-rt/uni0.jpg",
      "/images/europa/realmadrid/17-18-03-rt/uni1.jpg",
      "/images/europa/realmadrid/17-18-03-rt/uni2.jpg",
      "/images/europa/realmadrid/17-18-03-rt/uni3.jpg",
      "/images/europa/realmadrid/17-18-03-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 16/17 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2016",
      "2016 real",
      "2016",
      "real madrid 2016",
      "2016 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/16-17-01-rt/uni0.jpg",
      "/images/europa/realmadrid/16-17-01-rt/uni1.jpg",
      "/images/europa/realmadrid/16-17-01-rt/uni2.jpg",
      "/images/europa/realmadrid/16-17-01-rt/uni3.jpg",
      "/images/europa/realmadrid/16-17-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 16/17 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2016",
      "2016 real",
      "2016",
      "real madrid 2016",
      "2016 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/16-17-03-rt/uni0.jpg",
      "/images/europa/realmadrid/16-17-03-rt/uni1.jpg",
      "/images/europa/realmadrid/16-17-03-rt/uni2.jpg",
      "/images/europa/realmadrid/16-17-03-rt/uni3.jpg",
      "/images/europa/realmadrid/16-17-03-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 15/16 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2015",
      "2015 real",
      "2015",
      "real madrid 2015",
      "2015 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/15-16-01-rt/uni0.jpg",
      "/images/europa/realmadrid/15-16-01-rt/uni1.jpg",
      "/images/europa/realmadrid/15-16-01-rt/uni2.jpg",
      "/images/europa/realmadrid/15-16-01-rt/uni3.jpg",
      "/images/europa/realmadrid/15-16-01-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 15/16 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2015",
      "2015 real",
      "2015",
      "real madrid 2015",
      "2015 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/15-16-03-rt/uni0.jpg",
      "/images/europa/realmadrid/15-16-03-rt/uni1.jpg",
      "/images/europa/realmadrid/15-16-03-rt/uni2.jpg",
      "/images/europa/realmadrid/15-16-03-rt/uni3.jpg",
      "/images/europa/realmadrid/15-16-03-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 14/15 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2014",
      "2014 real",
      "2014",
      "real madrid 2014",
      "2014 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/14-15-02-rt/uni0.jpg",
      "/images/europa/realmadrid/14-15-02-rt/uni1.jpg",
      "/images/europa/realmadrid/14-15-02-rt/uni2.jpg",
      "/images/europa/realmadrid/14-15-02-rt/uni3.jpg",
      "/images/europa/realmadrid/14-15-02-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 14/15 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2014",
      "2014 real",
      "2014",
      "real madrid 2014",
      "2014 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/14-15-03-rt/uni0.jpg",
      "/images/europa/realmadrid/14-15-03-rt/uni1.jpg",
      "/images/europa/realmadrid/14-15-03-rt/uni2.jpg",
      "/images/europa/realmadrid/14-15-03-rt/uni3.jpg",
      "/images/europa/realmadrid/14-15-03-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 13/14 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2013",
      "2013 real",
      "2013",
      "real madrid 2013",
      "2013 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/13-14-03-rt/uni0.jpg",
      "/images/europa/realmadrid/13-14-03-rt/uni1.jpg",
      "/images/europa/realmadrid/13-14-03-rt/uni2.jpg",
      "/images/europa/realmadrid/13-14-03-rt/uni3.jpg",
      "/images/europa/realmadrid/13-14-03-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 12/13 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2012",
      "2012 real",
      "2012",
      "real madrid 2012",
      "2012 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/12-13-01-rt/uni0.jpg",
      "/images/europa/realmadrid/12-13-01-rt/uni1.jpg",
      "/images/europa/realmadrid/12-13-01-rt/uni2.jpg",
      "/images/europa/realmadrid/12-13-01-rt/uni3.jpg",
      "/images/europa/realmadrid/12-13-01-rt/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 12/13 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2012",
      "2012 real",
      "2012",
      "real madrid 2012",
      "2012 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/12-13-03-rt/uni0.jpg",
      "/images/europa/realmadrid/12-13-03-rt/uni1.jpg",
      "/images/europa/realmadrid/12-13-03-rt/uni2.jpg",
      "/images/europa/realmadrid/12-13-03-rt/uni3.jpg",
      "/images/europa/realmadrid/12-13-03-rt/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 11/12 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2011",
      "2011 real",
      "2011",
      "real madrid 2011",
      "2011 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/11-12-03-rt/uni0.jpg",
      "/images/europa/realmadrid/11-12-03-rt/uni1.jpg",
      "/images/europa/realmadrid/11-12-03-rt/uni2.jpg",
      "/images/europa/realmadrid/11-12-03-rt/uni3.jpg",
      "/images/europa/realmadrid/11-12-03-rt/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 09/10 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2009",
      "2009 real",
      "2009",
      "real madrid 2009",
      "2009 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/09-10-01-rt/uni0.jpg",
      "/images/europa/realmadrid/09-10-01-rt/uni1.jpg",
      "/images/europa/realmadrid/09-10-01-rt/uni2.jpg",
      "/images/europa/realmadrid/09-10-01-rt/uni3.jpg",
      "/images/europa/realmadrid/09-10-01-rt/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 07/08 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2007",
      "2007 real",
      "2007",
      "real madrid 2007",
      "2007 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/07-08-01-rt/uni0.jpg",
      "/images/europa/realmadrid/07-08-01-rt/uni1.jpg",
      "/images/europa/realmadrid/07-08-01-rt/uni2.jpg",
      "/images/europa/realmadrid/07-08-01-rt/uni3.jpg",
      "/images/europa/realmadrid/07-08-01-rt/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 06/07 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2006",
      "2006 real",
      "2006",
      "real madrid 2006",
      "2006 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/06-07-01-rt/uni0.jpg",
      "/images/europa/realmadrid/06-07-01-rt/uni1.jpg",
      "/images/europa/realmadrid/06-07-01-rt/uni2.jpg",
      "/images/europa/realmadrid/06-07-01-rt/uni3.jpg",
      "/images/europa/realmadrid/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 34,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 06/07 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2006",
      "2006 real",
      "2006",
      "real madrid 2006",
      "2006 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/06-07-03-rt/uni0.jpg",
      "/images/europa/realmadrid/06-07-03-rt/uni1.jpg",
      "/images/europa/realmadrid/06-07-03-rt/uni2.jpg",
      "/images/europa/realmadrid/06-07-03-rt/uni3.jpg",
      "/images/europa/realmadrid/06-07-03-rt/uni4.jpg",
    ],
  },
  {
    id: 35,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 05/06 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2005",
      "2005 real",
      "2005",
      "real madrid 2005",
      "2005 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/05-06-01-rt/uni0.jpg",
      "/images/europa/realmadrid/05-06-01-rt/uni1.jpg",
      "/images/europa/realmadrid/05-06-01-rt/uni2.jpg",
      "/images/europa/realmadrid/05-06-01-rt/uni3.jpg",
      "/images/europa/realmadrid/05-06-01-rt/uni4.jpg",
    ],
  },
  {
    id: 36,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 05/06 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2005",
      "2005 real",
      "2005",
      "real madrid 2005",
      "2005 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/05-06-02-rt/uni0.jpg",
      "/images/europa/realmadrid/05-06-02-rt/uni1.jpg",
      "/images/europa/realmadrid/05-06-02-rt/uni2.jpg",
      "/images/europa/realmadrid/05-06-02-rt/uni3.jpg",
      "/images/europa/realmadrid/05-06-02-rt/uni4.jpg",
    ],
  },
  {
    id: 37,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 05/06 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2005",
      "2005 real",
      "2005",
      "real madrid 2005",
      "2005 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/05-06-03-rt/uni0.jpg",
      "/images/europa/realmadrid/05-06-03-rt/uni1.jpg",
      "/images/europa/realmadrid/05-06-03-rt/uni2.jpg",
      "/images/europa/realmadrid/05-06-03-rt/uni3.jpg",
      "/images/europa/realmadrid/05-06-03-rt/uni4.jpg",
    ],
  },
  {
    id: 38,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 03/04 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2003",
      "2003 real",
      "2003",
      "real madrid 2003",
      "2003 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/03-04-01-rt/uni0.jpg",
      "/images/europa/realmadrid/03-04-01-rt/uni1.jpg",
      "/images/europa/realmadrid/03-04-01-rt/uni2.jpg",
      "/images/europa/realmadrid/03-04-01-rt/uni3.jpg",
      "/images/europa/realmadrid/03-04-01-rt/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 02/03 - Uniforme de Goleiro (Cinza) Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2002",
      "2002 real",
      "2002",
      "real madrid 2002",
      "2002 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/02-03-05-gc/uni0.jpg",
      "/images/europa/realmadrid/02-03-05-gc/uni1.jpg",
      "/images/europa/realmadrid/02-03-05-gc/uni2.jpg",
      "/images/europa/realmadrid/02-03-05-gc/uni3.jpg",
      "/images/europa/realmadrid/02-03-05-gc/uni4.jpg",
    ],
  },
  {
    id: 40,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 00/01 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 2000",
      "2000 real",
      "2000",
      "real madrid 2000",
      "2000 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/00-01-01-rt/uni0.jpg",
      "/images/europa/realmadrid/00-01-01-rt/uni1.jpg",
      "/images/europa/realmadrid/00-01-01-rt/uni2.jpg",
      "/images/europa/realmadrid/00-01-01-rt/uni3.jpg",
      "/images/europa/realmadrid/00-01-01-rt/uni4.jpg",
    ],
  },
  {
    id: 41,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 99/00 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1999",
      "1999 real",
      "1999",
      "real madrid 1999",
      "1999 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/99-00-02-rt/uni0.jpg",
      "/images/europa/realmadrid/99-00-02-rt/uni1.jpg",
      "/images/europa/realmadrid/99-00-02-rt/uni2.jpg",
      "/images/europa/realmadrid/99-00-02-rt/uni3.jpg",
      "/images/europa/realmadrid/99-00-02-rt/uni4.jpg",
    ],
  },
  {
    id: 42,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 99/00 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1999",
      "1999 real",
      "1999",
      "real madrid 1999",
      "1999 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/99-00-03-rt/uni0.jpg",
      "/images/europa/realmadrid/99-00-03-rt/uni1.jpg",
      "/images/europa/realmadrid/99-00-03-rt/uni2.jpg",
      "/images/europa/realmadrid/99-00-03-rt/uni3.jpg",
      "/images/europa/realmadrid/99-00-03-rt/uni4.jpg",
    ],
  },
  {
    id: 43,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 98/99 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1998",
      "1998 real",
      "1998",
      "real madrid 1998",
      "1998 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/98-99-01-rt/uni0.jpg",
      "/images/europa/realmadrid/98-99-01-rt/uni1.jpg",
      "/images/europa/realmadrid/98-99-01-rt/uni2.jpg",
      "/images/europa/realmadrid/98-99-01-rt/uni3.jpg",
      "/images/europa/realmadrid/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 44,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 97/98 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1997",
      "1997 real",
      "1997",
      "real madrid 1997",
      "1997 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/97-98-01-rt/uni0.jpg",
      "/images/europa/realmadrid/97-98-01-rt/uni1.jpg",
      "/images/europa/realmadrid/97-98-01-rt/uni2.jpg",
      "/images/europa/realmadrid/97-98-01-rt/uni3.jpg",
      "/images/europa/realmadrid/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 45,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 97/98 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1997",
      "1997 real",
      "1997",
      "real madrid 1997",
      "1997 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/97-98-02-rt/uni0.jpg",
      "/images/europa/realmadrid/97-98-02-rt/uni1.jpg",
      "/images/europa/realmadrid/97-98-02-rt/uni2.jpg",
      "/images/europa/realmadrid/97-98-02-rt/uni3.jpg",
      "/images/europa/realmadrid/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 46,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 97/98 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1997",
      "1997 real",
      "1997",
      "real madrid 1997",
      "1997 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/97-98-03-rt/uni0.jpg",
      "/images/europa/realmadrid/97-98-03-rt/uni1.jpg",
      "/images/europa/realmadrid/97-98-03-rt/uni2.jpg",
      "/images/europa/realmadrid/97-98-03-rt/uni3.jpg",
    ],
  },
  {
    id: 47,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 96/97 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1996",
      "1996 real",
      "1996",
      "real madrid 1996",
      "1996 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/96-97-03-rt/uni0.jpg",
      "/images/europa/realmadrid/96-97-03-rt/uni1.jpg",
      "/images/europa/realmadrid/96-97-03-rt/uni2.jpg",
      "/images/europa/realmadrid/96-97-03-rt/uni3.jpg",
      "/images/europa/realmadrid/96-97-03-rt/uni4.jpg",
    ],
  },
  {
    id: 48,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 94/95 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1994",
      "1994 real",
      "1994",
      "real madrid 1994",
      "1994 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/94-95-01-rt/uni0.jpg",
      "/images/europa/realmadrid/94-95-01-rt/uni1.jpg",
      "/images/europa/realmadrid/94-95-01-rt/uni2.jpg",
      "/images/europa/realmadrid/94-95-01-rt/uni3.jpg",
      "/images/europa/realmadrid/94-95-01-rt/uni4.jpg",
    ],
  },
  {
    id: 49,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 94/95 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1994",
      "1994 real",
      "1994",
      "real madrid 1994",
      "1994 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/94-95-02-rt/uni0.jpg",
      "/images/europa/realmadrid/94-95-02-rt/uni1.jpg",
      "/images/europa/realmadrid/94-95-02-rt/uni2.jpg",
      "/images/europa/realmadrid/94-95-02-rt/uni3.jpg",
      "/images/europa/realmadrid/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 50,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 90/91 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1990",
      "1990 real",
      "1990",
      "real madrid 1990",
      "1990 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/90-91-01-rt/uni0.jpg",
      "/images/europa/realmadrid/90-91-01-rt/uni1.jpg",
      "/images/europa/realmadrid/90-91-01-rt/uni2.jpg",
      "/images/europa/realmadrid/90-91-01-rt/uni3.jpg",
      "/images/europa/realmadrid/90-91-01-rt/uni4.jpg",
    ],
  },
  {
    id: 51,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 88/89 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1988",
      "1988 real",
      "1988",
      "real madrid 1988",
      "1988 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/88-89-01-rt/uni0.jpg",
      "/images/europa/realmadrid/88-89-01-rt/uni1.jpg",
      "/images/europa/realmadrid/88-89-01-rt/uni2.jpg",
      "/images/europa/realmadrid/88-89-01-rt/uni3.jpg",
      "/images/europa/realmadrid/88-89-01-rt/uni4.jpg",
    ],
  },
  {
    id: 52,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid 84/85 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "real 1984",
      "1984 real",
      "1984",
      "real madrid 1984",
      "1984 real madrid",
      "retro",
      "retro real madrid",
      "real madrid retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/realmadrid/84-85-03-rt/uni0.jpg",
      "/images/europa/realmadrid/84-85-03-rt/uni1.jpg",
      "/images/europa/realmadrid/84-85-03-rt/uni2.jpg",
      "/images/europa/realmadrid/84-85-03-rt/uni3.jpg",
      "/images/europa/realmadrid/84-85-03-rt/uni4.jpg",
    ],
  },
  {
    id: 53,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jb/uni0.jpg",
      "/images/europa/realmadrid/jb/uni1.jpg",
      "/images/europa/realmadrid/jb/uni2.jpg",
      "/images/europa/realmadrid/jb/uni3.jpg",
      "/images/europa/realmadrid/jb/uni4.png",
    ],
  },
  {
    id: 54,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jb1/uni0.jpg",
      "/images/europa/realmadrid/jb1/uni1.jpg",
      "/images/europa/realmadrid/jb1/uni2.jpeg",
      "/images/europa/realmadrid/jb1/uni3.jpeg",
      "/images/europa/realmadrid/jb1/uni4.jpeg",
    ],
  },
  {
    id: 55,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jb2/uni0.jpg",
      "/images/europa/realmadrid/jb2/uni1.jpg",
      "/images/europa/realmadrid/jb2/uni2.jpg",
      "/images/europa/realmadrid/jb2/uni3.jpg",
      "/images/europa/realmadrid/jb2/uni4.jpg",
    ],
  },
  {
    id: 56,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jb3/uni0.jpg",
      "/images/europa/realmadrid/jb3/uni1.jpg",
      "/images/europa/realmadrid/jb3/uni2.jpg",
      "/images/europa/realmadrid/jb3/uni3.jpg",
      "/images/europa/realmadrid/jb3/uni4.jpg",
    ],
  },
  {
    id: 57,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Branca/Azul)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jba/uni0.jpg",
      "/images/europa/realmadrid/jba/uni1.jpg",
      "/images/europa/realmadrid/jba/uni2.jpg",
      "/images/europa/realmadrid/jba/uni3.jpg",
      "/images/europa/realmadrid/jba/uni4.jpg",
    ],
  },
  {
    id: 58,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Branca/Preta)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jbp/uni0.jpg",
      "/images/europa/realmadrid/jbp/uni1.jpg",
      "/images/europa/realmadrid/jbp/uni2.jpg",
      "/images/europa/realmadrid/jbp/uni3.jpg",
    ],
  },
  {
    id: 59,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jp/uni0.jpg",
      "/images/europa/realmadrid/jp/uni1.jpg",
      "/images/europa/realmadrid/jp/uni2.jpg",
      "/images/europa/realmadrid/jp/uni3.jpg",
      "/images/europa/realmadrid/jp/uni4.png",
    ],
  },
  {
    id: 60,
    pais: "europa",
    liga: "la-liga",
    time: "real-madrid",
    nome: "Real Madrid - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "real madrid",
      "real",
      "merengues",
      "jaqueta",
      "jaqueta real madrid",
      "real madrid jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/realmadrid/jp1/uni0.jpg",
      "/images/europa/realmadrid/jp1/uni1.jpg",
      "/images/europa/realmadrid/jp1/uni2.jpg",
      "/images/europa/realmadrid/jp1/uni3.jpg",
    ],
  },
];

export default realmadrid;
